import { useCallback } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import IconButton from '@material-ui/core/IconButton';
import Popper from '@material-ui/core/Popper';
import IconClose from '@material-ui/icons/Close';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

import TooltipContent, { ICON_TYPE } from 'src/components/TooltipContent';

import useStyles from './useStyles';

export const CLOSE_REASON = {
  clickAway: 'clickAway',
  closeButton: 'closeButton',
};

const propTypes = {
  classes: PropTypes.shape({}),
  open: PropTypes.bool,
  anchor: PropTypes.instanceOf(Element),
  title: PropTypes.string,
  content: PropTypes.string,
  icon: PropTypes.oneOf(Object.values(ICON_TYPE)),
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
};

const defaultProps = {
  classes: null,
  open: false,
  anchor: null,
  title: null,
  content: null,
  icon: null,
  onClose: null,
  showCloseButton: false,
};

const TooltipExclamation = ({
  classes,
  open,
  anchor,
  title,
  content,
  icon,
  onClose,
  showCloseButton,
  ...restProps
}) => {
  const styles = useStyles({ classes });

  const handleClickAway = useCallback(() => {
    onClose(CLOSE_REASON.clickAway);
  }, [onClose]);

  const handleCloseClick = useCallback(() => {
    onClose(CLOSE_REASON.closeButton);
  }, [onClose]);

  if (!anchor) {
    return null;
  }

  return (
    <ClickAwayListener
      onClickAway={open ? handleClickAway : noop}
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
    >
      <Popper
        className={styles.popper}
        open={open}
        anchorEl={anchor}
        placement="top"
        data-testid="TooltipExclamation"
        {...restProps}
      >
        <div className={styles.root}>
          {showCloseButton && (
            <IconButton
              className={styles.closeButton}
              size="small"
              onClick={handleCloseClick}
              data-testid="TooltipExclamation__CloseButton"
            >
              <IconClose className={styles.closeButtonIcon} />
            </IconButton>
          )}

          <TooltipContent icon={icon} title={title} content={content} />
        </div>
      </Popper>
    </ClickAwayListener>
  );
};
TooltipExclamation.propTypes = propTypes;
TooltipExclamation.defaultProps = defaultProps;

export default TooltipExclamation;
